import React, { createContext, useContext, useEffect, useState } from "react";

const AuthCtx = createContext({ role: null, name: "", selfieUrl: null, login: () => {}, logout: () => {}, setName: () => {}, setSelfieUrl: () => {} });
export const useAuth = () => useContext(AuthCtx);

const KEY = "wedding_auth";
// Roles: "admin" | "guest" | "photographer"

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(() => {
    try {
      const v = localStorage.getItem(KEY);
      return v ? JSON.parse(v) : { role: null, name: "", selfieUrl: null };
    } catch {
      return { role: null, name: "", selfieUrl: null };
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(auth));
    } catch {}
  }, [auth]);

  const login = (role, name) => setAuth({ role, name: (name || "").trim(), selfieUrl: null });
  const logout = () => setAuth({ role: null, name: "", selfieUrl: null });
  const setName = (name) => setAuth((a) => ({ ...a, name }));
  const setSelfieUrl = (selfieUrl) => setAuth((a) => ({ ...a, selfieUrl }));

  return (
    <AuthCtx.Provider value={{ ...auth, login, logout, setName, setSelfieUrl }}>{children}</AuthCtx.Provider>
  );
}
